import React from 'react'
import './styles.scss'

import Button from '../Button'

import WhatsApp from '../../assets/svgs/WhatsApp'
import COLORS from '../../styles/colors'

export default function WhatsappButton() {
  const iconStyles =
    window.innerWidth > 720
      ? {
          width: 38,
          height: 32,
        }
      : {
          width: 28,
          height: 24,
        }

  const StyledIcon = <WhatsApp color={COLORS.primaryDark} style={iconStyles} />
  return (
    <Button
      title={'Entrar em contato'}
      Icon={StyledIcon}
      onClick={() => window.open('https://rebrand.ly/whatsappmellro', 'blank')}
      className={'whatsapp-button'}
    />
  )
}
